<div class="metin-notu-dialog">
  <!-- Toolbar - Point Selection -->
  <div class="catia-toolbar">
    <div class="toolbar-grup">
      <div class="ayar-satir">
        <button class="catia-btn" [class.active]="nokta" (click)="noktaSec()"
                style="flex: 1; background: linear-gradient(135deg, rgba(255, 0, 255, 0.15), rgba(255, 0, 255, 0.25)); border-color: rgba(255, 0, 255, 0.4); color: #FF00FF;">
          <i class="icon crosshairs"></i>
          {{nokta ? 'Nokta Secildi' : 'Nokta Sec'}}
        </button>
      </div>
    </div>
  </div>

  <!-- Deprecation Warning -->
  @if (deprecationUyarisi) {
  <div class="uyari-kutu" style="background: rgba(255, 165, 0, 0.15); border: 1px solid rgba(255, 165, 0, 0.4); padding: 8px; margin: 8px 0; border-radius: 4px; color: #FFA500; font-size: 11px;">
    {{deprecationUyarisi}}
  </div>
  }

  <!-- Validation Messages -->
  @if (validasyonMesajlari.length > 0) {
  <div class="uyari-kutu" style="background: rgba(255, 68, 68, 0.15); border: 1px solid rgba(255, 68, 68, 0.4); padding: 8px; margin: 8px 0; border-radius: 4px; color: #FF4444; font-size: 11px;">
    @for (mesaj of validasyonMesajlari; track mesaj) {
    <div>{{mesaj}}</div>
    }
  </div>
  }

  <!-- Control Panel -->
  <div class="kontrol-paneli">

    <!-- Tolerans Ayarlari -->
    <div class="ayar-sekme">
      <div class="sekme-baslik" (click)="toleransAyarlariAcik = !toleransAyarlariAcik">
        <i class="icon crosshairs"></i>
        <span>Tolerans Ayarlari</span>
        <div class="chevron" [class.right]="!toleransAyarlariAcik" [class.down]="toleransAyarlariAcik"></div>
      </div>

      @if (toleransAyarlariAcik) {
      <div class="sekme-icerik">
        <!-- Tolerans Tipi (Grouped) -->
        <div class="ayar-satir">
          <label>Tip:</label>
          <select [(ngModel)]="toleransTipi" (ngModelChange)="onToleransTipiDegisti()" class="catia-select">
            @for (grup of getGrupluToleransTipleri(); track grup.grup) {
            <optgroup [label]="grup.grup">
              @for (tip of grup.tipler; track tip.value) {
              <option [value]="tip.value" [style.color]="tip.deprecated ? '#FFA500' : 'inherit'">{{tip.label}}</option>
              }
            </optgroup>
            }
          </select>
        </div>

        <!-- Tolerans Zone Modifier -->
        <div class="ayar-satir">
          <label>Zon:</label>
          <select [(ngModel)]="toleransZonModifier" (ngModelChange)="onizlemeGuncelle()" class="catia-select">
            @for (mod of zonModifierlari; track mod.value) {
            <option [value]="mod.value">{{mod.label}}</option>
            }
          </select>
        </div>

        <!-- Deger -->
        <div class="ayar-satir">
          <label>Deger:</label>
          <div class="slider-kontrol">
            <input type="number" [(ngModel)]="deger" (ngModelChange)="onizlemeGuncelle()"
                   class="catia-input" style="width: 100%; padding: 0.25rem 0.3rem; height: 24px;"
                   step="0.001" min="0" />
          </div>
        </div>

        <!-- Materyal Durumu -->
        <div class="ayar-satir">
          <label>Materyal:</label>
          <select [(ngModel)]="materyal" (ngModelChange)="onizlemeGuncelle()" class="catia-select">
            @for (mat of materyalDurumlari; track mat.value) {
            <option [value]="mat.value">{{mat.label}}</option>
            }
          </select>
        </div>
      </div>
      }
    </div>

    <!-- Datum Ayarlari -->
    <div class="ayar-sekme">
      <div class="sekme-baslik" (click)="datumAyarlariAcik = !datumAyarlariAcik">
        <i class="icon circle outline"></i>
        <span>Datum Referanslari</span>
        @if (datumGerekli) {
        <span style="color: #FF4444; margin-left: 4px; font-size: 10px;">*Gerekli</span>
        }
        <div class="chevron" [class.right]="!datumAyarlariAcik" [class.down]="datumAyarlariAcik"></div>
      </div>

      @if (datumAyarlariAcik) {
      <div class="sekme-icerik">
        <!-- Datum 1 -->
        <div class="ayar-satir" style="flex-wrap: wrap; gap: 4px;">
          <label style="width: 60px;">Datum 1:</label>
          <input type="text" [(ngModel)]="datum1" (ngModelChange)="onizlemeGuncelle()"
                 class="catia-input" placeholder="A" maxlength="2"
                 style="width: 40px; padding: 0.25rem 0.3rem; height: 24px; text-transform: uppercase;" />
          <select [(ngModel)]="datum1Materyal" (ngModelChange)="onizlemeGuncelle()" class="catia-select" style="flex: 1; min-width: 80px;">
            @for (mat of materyalDurumlari; track mat.value) {
            <option [value]="mat.value">{{mat.label}}</option>
            }
          </select>
        </div>

        <!-- Datum 2 -->
        <div class="ayar-satir" style="flex-wrap: wrap; gap: 4px;">
          <label style="width: 60px;">Datum 2:</label>
          <input type="text" [(ngModel)]="datum2" (ngModelChange)="onizlemeGuncelle()"
                 class="catia-input" placeholder="B" maxlength="2"
                 style="width: 40px; padding: 0.25rem 0.3rem; height: 24px; text-transform: uppercase;" />
          <select [(ngModel)]="datum2Materyal" (ngModelChange)="onizlemeGuncelle()" class="catia-select" style="flex: 1; min-width: 80px;">
            @for (mat of materyalDurumlari; track mat.value) {
            <option [value]="mat.value">{{mat.label}}</option>
            }
          </select>
        </div>

        <!-- Datum 3 -->
        <div class="ayar-satir" style="flex-wrap: wrap; gap: 4px;">
          <label style="width: 60px;">Datum 3:</label>
          <input type="text" [(ngModel)]="datum3" (ngModelChange)="onizlemeGuncelle()"
                 class="catia-input" placeholder="C" maxlength="2"
                 style="width: 40px; padding: 0.25rem 0.3rem; height: 24px; text-transform: uppercase;" />
          <select [(ngModel)]="datum3Materyal" (ngModelChange)="onizlemeGuncelle()" class="catia-select" style="flex: 1; min-width: 80px;">
            @for (mat of materyalDurumlari; track mat.value) {
            <option [value]="mat.value">{{mat.label}}</option>
            }
          </select>
        </div>
      </div>
      }
    </div>

    <!-- Gelismis Ayarlar -->
    <div class="ayar-sekme">
      <div class="sekme-baslik" (click)="gelismisAyarlariAcik = !gelismisAyarlariAcik">
        <i class="icon cog"></i>
        <span>Gelismis</span>
        <div class="chevron" [class.right]="!gelismisAyarlariAcik" [class.down]="gelismisAyarlariAcik"></div>
      </div>

      @if (gelismisAyarlariAcik) {
      <div class="sekme-icerik">
        <!-- Profesyonel Mod -->
        <div class="ayar-satir">
          <label>Profesyonel:</label>
          <div class="checkbox-kontrol">
            <input type="checkbox" [(ngModel)]="profesyonelMod" (ngModelChange)="onizlemeGuncelle()" id="profMod" class="catia-checkbox">
            <label for="profMod" class="checkbox-label">FCF Sistemi</label>
          </div>
        </div>

        <!-- Birlestik Tolerans -->
        <div class="ayar-satir">
          <label>Birlestik:</label>
          <div class="checkbox-kontrol">
            <input type="checkbox" [(ngModel)]="birlestikTolerans" (ngModelChange)="onizlemeGuncelle()" id="birlestik" class="catia-checkbox">
            <label for="birlestik" class="checkbox-label">Aktif</label>
          </div>
        </div>

        @if (birlestikTolerans) {
        <!-- Birlestik Deger -->
        <div class="ayar-satir">
          <label>Deger 2:</label>
          <div class="slider-kontrol">
            <input type="number" [(ngModel)]="birlestikDeger" (ngModelChange)="onizlemeGuncelle()"
                   class="catia-input" style="width: 100%; padding: 0.25rem 0.3rem; height: 24px;"
                   step="0.001" min="0" />
          </div>
        </div>

        <!-- Birlestik Datumlar -->
        <div class="ayar-satir" style="gap: 4px;">
          <label style="width: 70px;">Datum 2:</label>
          <input type="text" [(ngModel)]="birlestikDatum1" (ngModelChange)="onizlemeGuncelle()"
                 class="catia-input" placeholder="A" maxlength="2"
                 style="width: 40px; padding: 0.25rem 0.3rem; height: 24px; text-transform: uppercase;" />
          <input type="text" [(ngModel)]="birlestikDatum2" (ngModelChange)="onizlemeGuncelle()"
                 class="catia-input" placeholder="B" maxlength="2"
                 style="width: 40px; padding: 0.25rem 0.3rem; height: 24px; text-transform: uppercase;" />
        </div>
        }
      </div>
      }
    </div>

    <!-- Gorunum Ayarlari -->
    <div class="ayar-sekme">
      <div class="sekme-baslik" (click)="gorunumAyarlariAcik = !gorunumAyarlariAcik">
        <i class="icon eye"></i>
        <span>Gorunum Ayarlari</span>
        <div class="chevron" [class.right]="!gorunumAyarlariAcik" [class.down]="gorunumAyarlariAcik"></div>
      </div>

      @if (gorunumAyarlariAcik) {
      <div class="sekme-icerik">
        <!-- Renk -->
        <div class="ayar-satir">
          <label>Renk:</label>
          <div class="renk-kontrol">
            <div class="renk-palette">
              @for (r of renkler; track r) {
              <div class="renk-kutu" [style.background-color]="r"
                   [class.secili]="renk === r"
                   (click)="renk = r; onizlemeGuncelle()"></div>
              }
            </div>
            <input type="color" [(ngModel)]="renk" (ngModelChange)="onizlemeGuncelle()" class="renk-input" />
          </div>
        </div>

        <!-- Font Boyutu -->
        <div class="ayar-satir">
          <label>Yazi Boyutu:</label>
          <div class="slider-kontrol">
            <input type="range" [(ngModel)]="boyut" (ngModelChange)="onizlemeGuncelle()"
                   min="8" max="24" step="1" />
            <span class="deger-gosterge">{{boyut}}px</span>
          </div>
        </div>

        <!-- Sabit Boyut -->
        <div class="ayar-satir">
          <label>Sabit Boyut:</label>
          <div class="checkbox-kontrol">
            <input type="checkbox" [(ngModel)]="sabitBoyut" (ngModelChange)="sabitBoyutDegistir()" id="sabitBoyutTolerans" class="catia-checkbox">
            <label for="sabitBoyutTolerans" class="checkbox-label">Aktif</label>
          </div>
        </div>
      </div>
      }
    </div>

  </div>

  <!-- FCF Preview Info -->
  @if (profesyonelMod && nokta) {
  <div class="onizleme-bilgi" style="background: rgba(0, 255, 255, 0.1); border: 1px solid rgba(0, 255, 255, 0.3); padding: 8px; margin: 8px 0; border-radius: 4px; font-size: 10px; color: #00FFFF;">
    <div style="font-weight: bold; margin-bottom: 4px;">ASME Y14.5-2018 / ISO 1101:2017</div>
    <div>Tip: {{toleransTipi}}</div>
    <div>Deger: {{getZonModifierSymbol()}}{{deger}}</div>
    @if (datum1) {
    <div>Datum: {{datum1}}{{datum2 ? '-' + datum2 : ''}}{{datum3 ? '-' + datum3 : ''}}</div>
    }
    @if (birlestikTolerans) {
    <div>Birlestik: {{birlestikDeger}}</div>
    }
  </div>
  }

  <!-- Action Bar -->
  <div class="aksiyon-bar">
    <button class="catia-btn ekle-btn" (click)="ekle()" [disabled]="!nokta">
      <i class="icon plus"></i>
      Ekle
    </button>
    <button class="catia-btn kapat-btn" (click)="kapat()">
      <i class="icon times"></i>
      Kapat
    </button>
  </div>
</div>
